module.exports = __webpack_public_path__ + "img/symbol_10.d916698b.png";